import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'

const initialState = {
  display: '2D',
  size: 'medium',
  aggregateProperty: 'count'
}

export const hexagonsSlice = createSlice({
  name: 'hexagons',
  initialState,
  reducers: {
    setAggregateProperty: (state, action) => {
      state.aggregateProperty = action.payload
    },
    setDisplay: (state, action) => {
      state.display = action.payload
    },

    setSize: (state, action) => {
      state.size = action.payload
    }
  }
})

const selectSize = (state) => state.hexagons.size

const selectDisplay = (state) => state.hexagons.display

export const selectAggregateProperty = (state) =>
  state.hexagons.aggregateProperty

export const useAggregateProperty = () => useSelector(selectAggregateProperty)

export const useSize = () => useSelector(selectSize)

export const useDisplay = () => useSelector(selectDisplay)

export const { setDisplay, setSize, setAggregateProperty } =
  hexagonsSlice.actions

export default hexagonsSlice.reducer
